import { lazy } from 'react';
import { ROUTE_ABOUT, ROUTE_ADMIN, ROUTE_ADMINPANEL, ROUTE_AGB, ROUTE_AUTO_LOGIN, ROUTE_CONTACT, ROUTE_COOKIES, ROUTE_HOME, ROUTE_IMPRINT, ROUTE_PRIVACYPOLICY, ROUTE_REGISTER, ROUTE_SERVICES, ROUTE_STORE, ROUTE_SYSTEM, ROUTE_VENDING_REGISTER, ROUTE_VIDEO } from 'src/config/routes';
import { ROUTE_ACCOUNT } from 'src/config/account-routes';
import { ROUTE_WELCOME } from 'src/config/welcome-routes';
import { RouteDescriptor } from '../SiteDefinition';

const System = lazy(() => import('src/pages/System'));
const AdminPanelHomeRoutes = lazy(() => import('src/adminPanel/components/pages/AdminPanelHomeRoutes'));
const AdminPanelV2Routes = lazy(() => import('src/adminPanelV2/AdminPanelV2Routes'));
const Contact = lazy(() => import('src/pages/Contact'));
const VideoPage = lazy(() => import('src/pages/video/VideoPage'));
const RegisterRoutes = lazy(() => import('src/pages/register/RegisterRoutes'));
const VendingRegistrationRoutes = lazy(() => import('src/pages/vendingRegistration/VendingRegistrationRoutes'));
const AccountRoutes = lazy(() => import('src/pages/account/AccountRoutes'));
const ServicesRoutes = lazy(() => import('src/pages/services/ServicesRoutes'));
const AboutRoutes = lazy(() => import('src/pages/about/AboutRoutes'));
const StoreRoutes = lazy(() => import('src/pages/store/StoreRoutes'));
const WelcomeRoutes = lazy(() => import('src/pages/welcome/WelcomeRoutes'));
const Imprint = lazy(() => import('src/pages/Imprint'));
const PrivacyPolicy = lazy(() => import('src/pages/PrivacyPolicy'));
const Agb = lazy(() => import('src/pages/Agb'));
const Cookies = lazy(() => import('src/pages/Cookies'));
const AutoLogin = lazy(() => import('src/pages/AutoLogin'));
const Home = lazy(() => import('src/pages/Home'));

export const coreSiteRoutes: RouteDescriptor[] = [
    {
        key: 'system',
        route: ROUTE_SYSTEM,
        component: System,
        condition: context => !context.isProduction,
    },
    {
        key: 'admin-panel',
        route: ROUTE_ADMIN,
        component: AdminPanelHomeRoutes,
    },
    {
        key: 'admin-panel-v2',
        route: ROUTE_ADMINPANEL,
        component: AdminPanelV2Routes,
    },
    {
        key: 'contact',
        route: ROUTE_CONTACT,
        component: Contact,
    },
    {
        key: 'video',
        route: ROUTE_VIDEO,
        component: VideoPage,
    },
    {
        key: 'register',
        route: ROUTE_REGISTER,
        component: RegisterRoutes,
    },
    {
        key: 'vending_register',
        route: ROUTE_VENDING_REGISTER,
        component: VendingRegistrationRoutes,
    },
    {
        key: 'account',
        route: ROUTE_ACCOUNT,
        component: AccountRoutes,
    },
    {
        key: 'services',
        route: ROUTE_SERVICES,
        component: ServicesRoutes,
    },
    {
        key: 'about',
        route: ROUTE_ABOUT,
        component: AboutRoutes,
    },
    {
        key: 'store',
        route: ROUTE_STORE,
        component: StoreRoutes,
    },
    {
        key: 'welcome',
        route: ROUTE_WELCOME,
        component: WelcomeRoutes,
    },
    {
        key: 'imprint',
        route: ROUTE_IMPRINT,
        component: Imprint,
    },
    {
        key: 'privacy',
        route: ROUTE_PRIVACYPOLICY,
        component: PrivacyPolicy,
    },
    {
        key: 'agb',
        route: ROUTE_AGB,
        component: Agb,
    },
    {
        key: 'cookies',
        route: ROUTE_COOKIES,
        component: Cookies,
    },
    {
        key: 'auto-login',
        route: ROUTE_AUTO_LOGIN,
        component: AutoLogin,
    },
    {
        key: 'home',
        route: ROUTE_HOME,
        component: Home,
    }
];
